import { sbEditable, SbEditableBlok } from '@storyblok/storyblok-editable'
import * as React from 'react'
import styled from 'styled-components'
import { TitleWithPrefix } from '../../components/UI/TitleWithPrefix'
import { containerDefault } from '../../lib/styles/Container'
import { typoParagraphIntro } from '../../lib/styles/Typography'
import { ButtonBlok } from '../../types'
import { ButtonModule } from '../Button'
import { useProductKitDownload } from '../../lib/hooks/useDownloadProductKit'
import useQueryParam from '../../lib/hooks/useQueryParam'
import { Icon } from '../../components/UI'
import CustomLink from '../../components/CustomLink'

export interface HeroTitleDynamicBlok extends SbEditableBlok {
  preline?: string
  headline: string
  subline?: string
  buttons?: ButtonBlok[]
  headlineSize: 'xlarge' | 'large' | 'medium'
  alignment: 'left' | 'center'
  headlineSyntax: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
}

export interface HeroTitleDynamicProps {
  blok: HeroTitleDynamicBlok
}

const Wrapper = styled.div<{
  alignment: 'left' | 'center'
}>`
  ${containerDefault}
  margin-block: 4rem;
  margin-inline: auto;
  text-align: ${({ alignment }) => alignment};
`

const Subline = styled.div<{ $alignment: 'left' | 'center'; $largeMargin?: boolean }>`
  ${typoParagraphIntro}
  margin-inline: ${p => (p.$alignment === 'left' ? '0' : 'auto')};
  margin-top: ${p => (p.$largeMargin ? '1.5rem' : '1rem')};
  max-width: 36rem;
`

const Buttons = styled.div<{ $alignment: 'left' | 'center'; $largeMargin?: boolean }>`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  justify-content: ${({ $alignment }) => ($alignment === 'left' ? 'flex-start' : 'center')};
  margin-top: ${p => (p.$largeMargin ? '3rem' : '2.5rem')};
`
const ClickHereButton = styled.button`
    background: none;
    border: none;
    color: var(--color-primary);
    cursor: pointer;
    // font-weight: 700;
    padding: 0;
    text-decoration: underline;
  `
const StyledScroll = styled.div`
  color: var(--color-primary);
  cursor: pointer;
  
  text-decoration: none;
`

const StyledContactTeaser = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  font-size: 1rem;
  line-height: 110%;
  text-align: left;
  margin: 2rem 0 0;
`

export const HeroTitleDynamic = ({ blok }: HeroTitleDynamicProps) => {
  const [headline, setHeadline] = React.useState<string>(blok.headline)
  // if use params from gatsby router to set headline
  const [pkg, setPkg] = useQueryParam('package', '');

  return (
    <Wrapper alignment={blok.alignment || 'center'} {...sbEditable(blok)}>
      <TitleWithPrefix
        title={blok.firstRowHeadline}
        headlineSize={blok.headlineSize}
        headlineType={blok.headlineSyntax}
        textAlign={blok.alignment}
      />
      <TitleWithPrefix
        prefix={blok.preline}
        title={headline}
        headlineSize={blok.headlineSize}
        headlineType={blok.headlineSyntax}
        textAlign={blok.alignment}
        color={'#0D59F2'}
      />
      {
        blok.buttons && blok.buttons.length > 0 && (
          <Buttons $alignment={blok.alignment} $largeMargin={blok.headlineSize === 'xlarge'}>
            {blok.buttons.map((button, i) => (
              <ButtonModule key={i} blok={button} />
            ))}
          </Buttons>
        )
      }
    </Wrapper >
  )
}
